import { useMemo } from "react";

import { useIntl } from "react-intl";

import { DeliveryType } from "flows/Inbound/stores/inboundStore/types";
import { useCountryCode } from "shared/hooks/useCountryCode";

export type DeliveryOption = { key: DeliveryType; label: string };

// Additional countries can be added here as needed
const DELIVERY_OPTIONS_BY_COUNTRY: Record<string, DeliveryType[]> = {
  de: [DeliveryType.REWE],
  nl: [DeliveryType.Lekkerland],
};

export function useDeliveryOptions(): DeliveryOption[] {
  const intl = useIntl();
  const countryCode = useCountryCode() || "";

  const allOptions = useMemo<DeliveryOption[]>(
    () => [
      { key: DeliveryType.REWE, label: "REWE" },
      { key: DeliveryType.Lekkerland, label: "Lekkerland" },
      {
        key: DeliveryType.OtherDelivery,
        label: intl.formatMessage({ id: "flows.inbound.select-delivery.selection.other-delivery" }),
      },
      {
        key: DeliveryType.NotDelivery,
        label: intl.formatMessage({ id: "flows.inbound.select-delivery.selection.not-delivery" }),
      },
    ],
    [intl],
  );

  return useMemo(() => {
    const mainOptionKeys = DELIVERY_OPTIONS_BY_COUNTRY[countryCode] || [];
    const keysToInclude = [...mainOptionKeys, DeliveryType.OtherDelivery, DeliveryType.NotDelivery];
    const optionsMap = new Map(allOptions.map((opt) => [opt.key, opt]));
    return keysToInclude.map((key) => optionsMap.get(key)).filter(Boolean) as DeliveryOption[];
  }, [allOptions, countryCode]);
}
